module.exports = __webpack_public_path__ + "static/media/noti-update.98f9ec8e.svg";